import { updateUser } from '@/actions/userActions'
import { TosVersion } from '@/constants/businessConstants'
import { useAppDispatch } from '@/utils/typeHelpers'
import { Button, Alert, Dialog } from '@/ui'
import { TermsOfServiceCopy } from './TermsOfServiceCopy'

interface Props {
  currentUserId: number
}

export const TermsOfServiceModal = ({ currentUserId }: Props) => {
  const dispatch = useAppDispatch()

  const acceptNewTerms = async () => {
    const data = {
      tosVersion: TosVersion.tos_02_2022,
      tosAcceptedOn: Date.now(),
    }
    /* Update user — don't need to do anything after because the returned user will close the modal */
    await updateUser(currentUserId, data)(dispatch)
  }

  return (
    <Dialog open>
      <Dialog.Content size="md">
        <Dialog.Title>Changes to our Terms of Service</Dialog.Title>

        <Alert
          variant="default"
          title="Changes to our Terms of Service"
          description="We have made some changes to our Terms of Service. Please review and accept, thank you!"
        />
        <br />
        <div className="h-[350px] overflow-y-scroll">
          <TermsOfServiceCopy />
        </div>
        <Dialog.Footer>
          <Button onClick={acceptNewTerms}>Accept New Terms</Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
